import { FC, MouseEvent } from 'react';
import cx from 'classnames';
interface UIBlockButtonProps {
  icon: JSX.Element;
  title: string;
  description: string;
  // eslint-disable-next-line no-unused-vars
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  flat?: boolean;
}

const UIBlockButton: FC<UIBlockButtonProps> = ({
  icon,
  title,
  description,
  onClick,
  flat = false
}) => {
  return (
    <button
      onClick={onClick}
      className={cx(
        'flex w-full items-center justify-between rounded-[6px] bg-white py-[22px] px-[30px] transition-all duration-200 hover:shadow-block',
        {
          'border border-brand-grey400': flat
        }
      )}>
      <div className="flex-shrink-0 text-brand-black100">{icon}</div>
      <div className="ml-[30px] flex flex-auto flex-col items-start">
        <span className="mb-[6px] text-[16px] font-medium text-left leading-[18px] text-brand-black100 ">
          {title}
        </span>
        <span className="text-[12px] leading-[12px] text-left text-brand-grey450">
          {description}
        </span>
      </div>
    </button>
  );
};

export default UIBlockButton;
